<template>
  <div
    class="list-item"
    @click="clickItem(jobItemData)"
  >
    <div class="post-title flex items-center justify-between">
      <span>{{ jobItemData.job_post }}</span>
      <span class="salary-text">{{ jobItemData.display_salary }}</span>
    </div>
    <div class="tags-container flex items-center flex-wrap">
      <div
        v-for="(tag, tagIndex) in jobItemData.job_tags"
        :key="tagIndex"
        class="tag-item"
      >
        {{ tag }}
      </div>
    </div>
    <div
      class="flex justify-between items-center"
      style="margin-top: 8px"
    >
      <div class="left-wrapper">
        <div class="flex items-center">
          <img
            :src="jobItemData.company_logo"
            alt=""
            class="company-logo"
          />
          <span class="text">{{ jobItemData.company_nick_name }}</span>
          <span class="text">{{ jobItemData.company_industry }}</span>
          <span class="text">{{ jobItemData.company_scale }}</span>
        </div>
      </div>
      <div class="match-rate">该职位与你的简历匹配度为98%</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PositionItem',
  props: {
    jobItemData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  methods: {
    clickItem(item) {
      this.$emit('clickItem', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.post-title {
  font-size: 18px;
  color: #404040;
  font-weight: 600;
  margin-bottom: 8px;
  .salary-text {
    color: #ff6644;
  }
}
.tags-container {
  height: 24px;
  overflow: hidden;
  .tag-item {
    display: flex;
    align-items: center;
    color: #9c9c9c;
    font-size: 12px;
    margin-right: 6px;
    padding: 0 10px;
    height: 24px;
    border-radius: 2px;
    background-color: #f9f9f9;
  }
}
.left-wrapper {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.company-logo {
  width: 26px;
  height: 26px;
  border-radius: 2px;
  border: 1px solid #ececec;
  margin-right: 8px;
}
.text {
  display: flex;
  align-items: center;
  color: #606060;
  font-size: 14px;
  white-space: nowrap;
  &:not(:last-child)::after {
    content: '';
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #606060;
    margin: 0 8px;
  }
}
.match-rate {
  color: #9c9c9c;
  font-size: 12px;
}
</style>
